import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.$gridBottom = this.$('grid-bottom')[0]
        this.$title = this.$('title')[0]
    }

    init() {
        this.compute();

        this.checkResizeBind = this.checkResize.bind(this)
        window.addEventListener('resize', this.checkResizeBind)
    }

    checkResize() {
        if(!this.resizeTick) {
            this.resizeTick = true
            requestAnimationFrame(() => {
                this.compute()
                this.resizeTick = false
            })
        }
    }

    compute() {
        this.$gridBottom.style.setProperty('--first-row-size', '')

        const gridBottomBCR = this.$gridBottom.getBoundingClientRect();
        const titleBCR = this.$title.getBoundingClientRect();

        this.$gridBottom.style.setProperty('--first-row-size', `max(${titleBCR.height}px, calc(${gridBottomBCR.height}px - var(--second-row-size) - var(--grid-gutter) * 2))`)
    }

    destroy() {
        window.removeEventListener('resize', this.checkResizeBind)
    }
}
